import { Skeleton, Stack } from "@chakra-ui/react";
import React from "react";

const FileShimmer = ({ width = "220px", height = "150px" }) => {
  return (
    <Stack
      direction="row"
      spacing={4}
      width={width}
      height={height}
      display={"flex"}
      alignItems={"center"}
    >
      {/* Left-side rectangle for preview */}
      <Skeleton height="100px" width="100px" borderRadius="md" />

      {/* Right-side text placeholders */}
      <Stack flex="1" spacing={3}>
        <Skeleton height="20px" width="90%" borderRadius="xl" />
        <Skeleton height="20px" width="80%" borderRadius="xl" />
        <Skeleton height="20px" width="60%" borderRadius="xl" />
      </Stack>
    </Stack>
  );
};

export default FileShimmer;
